export class ConstantsTableColsRubrik {
  static readonly SOC_NAME: string = "SOC_NAME";
  static readonly SOC_CODE: string = "SOC_CODE";
  static readonly MENGEEINHEIT: string = "MENGEEINHEIT";
  static readonly DATENEINGABE: string = "DATENEINGABE";

  public static getColumns(): string[] {
    return [this.SOC_NAME, this.SOC_CODE, this.DATENEINGABE, this.MENGEEINHEIT];
  }
}
